import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const RoutePersist = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Store the current route in localStorage
  useEffect(() => {
    localStorage.setItem('lastRoute', location.pathname);
  }, [location]);

  // Restore the last visited route
  useEffect(() => {
    const lastRoute = localStorage.getItem('lastRoute');
    if (lastRoute && lastRoute !== location.pathname) {
        navigate(lastRoute, { replace: true });
    }
}, [location.pathname, navigate]); // Add location.pathname and navigate as dependencies

  return null;
};

export default RoutePersist;
